<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <h4 class="pull-right">Катеория узгартириш</h4>
          </header>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form autcomplete="off" @submit.prevent="productUpdate()">
                  <div class="form-group">
                    <label>titleRus</label>
                    <input type="text" class="form-control" v-model="product.title" />
                  </div>
                  <!-- <div class="form-group">
                    <label>titleUzl</label>
                    <input type="text" class="form-control" v-model="product.titleUzl" />
                  </div>
                  <div class="form-group">
                    <label>titleUzk</label>
                    <input type="text" class="form-control" v-model="product.titleUzk" />
                  </div>
                  <div class="form-group">
                    <label>version</label>
                    <input type="text" class="form-control" v-model="product.version" />
                  </div> -->
                  <div class="form-group">
                    <label>code</label>
                    <input type="text" class="form-control" v-model="product.code" />
                  </div>
                  <button type="submit" class="btn btn-primary">Изменить</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { EDIT, POST, GET } from "../../shared/api";
export default {
  data() {
    return {
      product: {},
      categories: []
    };
  },
  methods: {
    getProduct() {
      GET([], "/product/" + this.$route.params.product_id, this, false).then(
        response => {
          this.product = response;
        }
      );
    },
    productUpdate() {
      POST(this.product, "/productUpdate", this).then(response => {
        this.$router.push({
          name: "productsByCategory",
          params: {
            category_id: this.$route.params.category_id
          }
        });
      });
    }
  },
  created() {
    this.getProduct();
  }
};
</script>
